import { Checkbox, FormControlLabel } from '@mui/material';
import { Controller, Control } from 'react-hook-form';
import { CheckboxProps } from '@mui/material/Checkbox/Checkbox';
import { FC, ReactNode } from 'react';

interface ReactHookFormCheckboxProps extends CheckboxProps {
    name: string;
    control: Control<any>;
    label: ReactNode;
    multiple?: boolean;
    value?: string | number | boolean;
    labelPlacement?: 'start' | 'top' | 'bottom' | 'end';
}

const ReactHookFormCheckbox: FC<ReactHookFormCheckboxProps> = ({
    name,
    control,
    label,
    labelPlacement = 'end',
    multiple = false,
    value,
    ...props
}) => {
    // Helper function for handling multiple checkbox selection
    const handleMultipleChange = (checked: boolean, fieldValue: any[]) => {
        if (checked) {
            return [...fieldValue, value];
        }
        return fieldValue.filter((v) => v !== value);
    };

    return (
        <FormControlLabel
            control={
                <Controller
                    name={name}
                    control={control}
                    defaultValue={multiple ? [] : false}
                    render={({ field }) => (
                        <Checkbox
                            {...field}
                            {...props}
                            checked={multiple ? field.value.includes(value) : field.value}
                            onChange={(e) => {
                                const isChecked = e.target.checked;

                                if (multiple && value !== undefined) {
                                    field.onChange(handleMultipleChange(isChecked, field.value || []));
                                } else {
                                    field.onChange(isChecked);
                                }
                            }}
                        />
                    )}
                />
            }
            label={label}
            labelPlacement={labelPlacement}
        />
    );
};

export default ReactHookFormCheckbox;
